"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _intlDesignUi = require("@tencent/intl-design-ui");
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MultipleChoiceInput = ({
  name,
  required,
  onChange,
  onBlur,
  onFocus,
  data,
  multipleChoice = [],
  placeholder
}) => {
  const selectRef = (0, _react.useRef)(null);
  const _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    inputValue = _useState4[0],
    setInputValue = _useState4[1];
  const _useState5 = (0, _react.useState)(multipleChoice),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    options = _useState6[0],
    setOptions = _useState6[1];
  const valueChange = event => {
    const value = event.target.value.trim();
    let filterList = multipleChoice;
    if (value) {
      filterList = multipleChoice.filter(item => item.toUpperCase().indexOf(value.toUpperCase()) >= 0);
    }
    setInputValue(value);
    setOptions([...filterList]);
  };
  const valueFocus = event => {
    valueChange(event);
    onFocus();
  };
  const valueBlur = () => {
    onBlur();
  };
  const optionClick = item => {
    setIsOpen(false);
    setInputValue(item);
    onChange(item);
  };
  const closeDownList = event => {
    if (!selectRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };
  (0, _react.useEffect)(() => {
    if (!isOpen && inputValue && !options.includes(inputValue)) {
      setInputValue('');
      onChange('');
    }
    document.addEventListener('click', closeDownList, false);
    return () => {
      document.removeEventListener('click', closeDownList, false);
    };
  }, [isOpen, inputValue, options]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'intl-form-item': true,
      'rno-form-item': true,
      'rno-form-item-multipleChoice': true,
      'rno-form-required': required,
      'rno-form-status-error': data.isError
    })
  }, name && /*#__PURE__*/_react.default.createElement("label", {
    className: "form-component-label-s"
  }, name, required && /*#__PURE__*/_react.default.createElement("span", null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "rno-form-controls",
    ref: selectRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "i-form-combo-mod"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('rno-select rno-select-placeholder rno-select-full-width ', {
      'rno-select-open': isOpen
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "region_box",
    onClick: () => setIsOpen(true)
  }, /*#__PURE__*/_react.default.createElement("input", {
    placeholder: placeholder,
    className: "rno-input",
    value: inputValue,
    onChange: valueChange,
    onBlur: valueBlur,
    onFocus: valueFocus
  }), /*#__PURE__*/_react.default.createElement(_intlDesignUi.Icon, {
    name: "arrow-down",
    size: 24,
    color: 'rgba(0, 0, 0, 0.3)',
    className: "arrow-down"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "rno-dropdown rno-select-dropdown rno-dropdown-bottom"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "rno-dropdown-menu"
  }, options.map((item, index) => /*#__PURE__*/_react.default.createElement("li", {
    className: "rno-dropdown-menu-item",
    onClick: () => optionClick(item),
    key: `phone_input_${index}`
  }, /*#__PURE__*/_react.default.createElement("span", null, item))))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "rno-form-message"
  }, data.errMsg || '')));
};
var _default = exports.default = MultipleChoiceInput;